import { Link } from 'react-router'
import { LuArrowRight } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { primaryLink } from '@/components/ui/linkStyles'
import { approach } from '@/data/womensHealth'

export const WomensHealthApproach = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader
            title="Whole-person support,"
            accent="not just symptom relief"
            className="mb-6"
          />
          <Reveal>
            <p className="mb-8 text-base leading-7 text-base-600">
              Kandake's approach to women's health goes beyond managing symptoms. Each protocol is
              designed to address the underlying hormonal, nutritional, emotional, and environmental
              causes of imbalance using the wisdom of plant medicine alongside modern clinical
              understanding.
            </p>
            <Link to={`${ROUTES.CONTACT}?service=womens-health`} className={primaryLink}>
              Book a Consultation
              <LuArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
            </Link>
          </Reveal>
        </div>

        <ol className="space-y-4">
          {approach.map((a, index) => (
            <li key={a.n}>
              <Reveal delay={index * 80}>
                <div className="flex gap-5 rounded-3xl border border-base-200 bg-base-50 p-6 transition-colors hover:border-green-300">
                  <span className="shrink-0 pt-0.5 font-display text-sm text-gold-500">{a.n}</span>
                  <div>
                    <h3 className="mb-1.5 font-display text-xl text-base-900">{a.title}</h3>
                    <p className="text-sm leading-6 text-base-600">{a.desc}</p>
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
)
